import { render, staticRenderFns } from "./taraf.component.vue?vue&type=template&id=c2938716"
import script from "./taraf.component.vue?vue&type=script&lang=ts"
export * from "./taraf.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports